<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success" @click="onClickEditAccessoCategoria(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Elimina" variant="outline-danger" @click="onClickDeleteAccessoCategoria(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <rsa-configurazione-pai-domiciliare-accessi-categorie-modal-edit-component-vue ref="cmpRsaConfigurazionePaiDomiciliareAccessiCategorie" @afterSaveAccessiCategoria="onAfterSaveAccessiCategoria"></rsa-configurazione-pai-domiciliare-accessi-categorie-modal-edit-component-vue>
            <b-row class="sa-label-info">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponentVue from "./RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponent.vue";

export default {
    components: { RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponentVue },
    mixins: [UtilityMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapaidomiciliareaccessicategorie",
            listKey: 0,
            items: [],
            filtroConfigurazioneParametriVitali: {},
            fields: [
                { key: "index", label: "*" },
                { key: "codice", label: "Codice" },
                { key: "descrizione", label: "Descrizione" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
        };
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },

    methods: {
        loadData() {
            let me = this;
            me.openShowModalLoading();
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioneParametriVitali"]) {
                me.filtroConfigurazioneParametriVitali = JSON.parse(sessionStorage["filtroConfigurazioneParametriVitali"]);
            }
            me.filtroConfigurazioneParametriVitali.page = me.currentPage;
            me.filtroConfigurazioneParametriVitali.forPage = me.perPage;
            me.loadDataResources(me.pathResource, me.filtroConfigurazioneParametriVitali, me.loadAccessiCategorieSuccess, null);
            me.closeShowModalLoading();
        },
        loadAccessiCategorieSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },

        onClickEditAccessoCategoria(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazionePaiDomiciliareAccessiCategorie.show(item.id);
        },
        onClickNuovCategoria() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePaiDomiciliareAccessiCategorie.show();
        },
        onClickDeleteAccessoCategoria(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questa Categoria: " + item.descrizione, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAccessoCategoria(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteAccessoCategoria(id) {
            let me = this;
            me.deleteResource(me.pathResource + "/" + id, me.deleteVociMenuSuccess, me.deleteVociMenuError);
        },
        onAfterSaveAccessiCategoria() {
            this.loadData();
        },
    },
};
</script>
